<template>
  <div class="app-wrapper" :class="classObj">
    <div v-if="!is_new_page">
      <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
      <div class="myTopBanner" :style="activeClass" >
        <a href="./#/">
          <img v-if="IsPerm('核对管理') && !IsPerm('社会救助救助')" src="@/assets/imgs/hdzx_logo.png" alt="logo"
            style="padding-top:8px;margin-left:15px;margin-right:10px;float:left;" width="30" />
            <img v-else src="@/assets/imgs/logo1.png" alt="logo"
            style="padding-top:8px;margin-left:15px;margin-right:10px;float:left;" width="30" />
        </a>
        <div class="title">
          <a href="./#/">
            <div style="float:left;padding-top:12px;">新疆维吾尔自治区<span v-if="IsPerm('社会救助救助')">社会救助管理</span><span v-if="IsPerm('核对管理') && !IsPerm('社会救助救助')">居民家庭经济状况核对</span><span v-if="IsPerm('核对管理') && IsPerm('社会救助救助')">及居民家庭经济状况核对</span>系统</div>

          </a>


          <TopMenu style="width:55%;margin-right:0px;margin-left:50px;float:left;"></TopMenu>
          <el-dropdown class="avatar-container right-menu-item" trigger="click">

            <div class="avatar-wrapper">
              &nbsp;&nbsp;{{ $store.state.user.dept_name }}
              <span v-if="$store.getters.state !== null">&nbsp;{{ state_name }}</span>
              <span v-if="$store.getters.county !== null">-{{ county_name }}</span>
              <span v-if="$store.getters.town !== null">-{{ town_name }}</span>
              &nbsp;&nbsp;&nbsp;<svg-icon icon-class="用户" transform="scale(1)" />
              <span v-if="$store.getters.device !== 'mobile'">&nbsp;{{ userName }}&nbsp;</span>
              <i class="el-icon-arrow-down"></i>
              &emsp;<el-button type="text" icon="el-icon-question" style="font-size:1rem;color:#fff;line-height: -1rem;" @click="dialogPdf">系统帮助</el-button>
              <span style="font-size:0.8rem">&emsp;系统版本：{{getVersion()}}</span>
            </div>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided>
                <span @click="showUpdatePwd" style="display:block;">修改密码</span>
              </el-dropdown-item>
              <el-dropdown-item divided>
                <span @click="logout" style="display:block;">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>

          </el-dropdown>
        </div>



      </div>

      <sidebar class="sidebar-container" :style="{ width: '240px' }">
      </sidebar>
      <tags-view
        :style="{ width: sidebar.opened ? 'calc(100% - 240px)' : 'calc(100% - 37px)', left: sidebar.opened ? '240px' : '37px', }"></tags-view>
    </div>
    <app-main v-if="!is_new_page" class="main-container"
      :style="{ width: sidebar.opened ? 'calc(100% - 240px)' : 'calc(100% - 37px)', left: sidebar.opened ? '240px' : '37px', }"></app-main>
    <app-main v-else
      :style="{ width: sidebar.opened ? 'calc(100%)' : 'calc(100% )', left: '10px', top: '0px' }"></app-main>

    <el-dialog title="修改密码" :visible.sync="showUpdatePwdDiag" :close-on-click-modal=false :show-close=false>
      <P><el-lable v-if="pwdUpdated == false"
          style="color:#ff0000;font-size: large; text-align: center; width:500px">您正在使用的是初始密码，您必须重新设置您的密码</el-lable></P>
      <br />
      <el-form ref="dataForm" :model="temp" :rules="rules" label-position="right" size="mini" label-width="150px"
        style='width: 500px;'>
        <el-form-item size="medium" label="旧密码" prop="old_pwd" required>
          <el-input v-model="temp.old_pwd" type="password"></el-input>
        </el-form-item>
        <el-form-item size="medium" label="">
          <!--el-tag style="color:#ff0000;">新密码至少8位字符</el-tag-->
        </el-form-item>
        <el-form-item size="medium" label="新密码" prop="pwd" required>
          <el-input v-model="temp.pwd" type="password"></el-input>
        </el-form-item>

        <el-form-item size="medium" label="再次输入新密码" prop="pwd1" required>
          <el-input v-model="temp.pwd1" type="password"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button v-if="pwdUpdated" @click="showUpdatePwdDiag = false">取消</el-button>

        <el-button type="primary" @click="updatePwd">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="系统帮助" :visible.sync="showDialogPDF" width="80%">
			<pdf v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf>
		</el-dialog>
  </div>
</template>

<script>
/* 备份
style="height: 100%;padding: 40px 0px 0px 0px; box-sizing: border-box ;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;"
*/
import { Sidebar, AppMain, TagsView, Navbar } from './components'
import TopMenu from '@/components/topMenu/'
import ResizeMixin from './mixin/ResizeHandler'
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import { getToken, setToken } from '@/utils/auth'
import sys_user_api from '@/api/sys_user'
import { isPerm } from '@/utils/is_perm'
import pdf from 'vue-pdf'
import { get_version } from '@/utils/get_version'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    TopMenu,
		pdf
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapGetters([
      'state_id',
      'state_name',
      'sidebar',
      'userName',
      'type',
      'biz_type',
      'level',
      'county',
      'county_name',
      'town',
      'town_name',
      'unit',
      'menu',
      'perms',
      'roles'
    ]),
    backgroundStyle(){
      if(this.IsPerm('核对管理')){

        return { backgroundColor: '#409EFF' }

      }
      return {}
    },
    activeClass() {
      return this.IsPerm('核对管理') ? 'background: #8cc5ff;' : '';
    },
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  data() {
    return {
      pdfUrl:"https://shjz.mzt.xinjiang.gov.cn/mzjz-admin/help20250331.pdf",
      numPages: 1,
      showDialogPDF:false,
      is_new_page:false,
      isActive:true,
      is_stats:false,
      activeMenu: Cookies.get('activeMenu') ? Cookies.get('activeMenu') + '' : '0',
      top: 0,
      left: 0,
      selectedTag: {},
      accept_mode: '否',
      ws: null,
      interval_start_msg: null,
      interval_keep_alive: null,

      temp: {},
      showUpdatePwdDiag: false,
      pwdUpdated: true,

      rules: {
        pwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,}$/, message: '密码不得少于8个字符，且须包含大写字母、小写字母、数字', trigger: 'blur' }
        ],
        pwd1: [
          { required: true, message: '再次输入新密码', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,}$/, message: '密码不得少于8个字符，且须包含大写字母、小写字母、数字', trigger: 'blur' }
        ]
      }
    }
  },

  created() {

    this.is_new_page=window.location.href.split('#')[1].includes('new_page')
    if (Cookies.get('activeMenu')) {
      this.$store.commit('SET_MENU2', this.menu[Cookies.get('activeMenu')].children)
    } else {
      this.$store.commit('SET_MENU2', this.menu[0].children)
    }
    if(window.location.href.split('#')[1] == '/stats') {
          this.is_stats = true
        }else{
          this.is_stats = false
        }
  },
  methods: {
    getVersion(){
      return get_version()
    },
    dialogPdf(){
      this.showDialogPDF=true
      this.getNumPages()
    },
    getNumPages() {
			let loadingTask = pdf.createLoadingTask(this.pdfUrl)
			loadingTask.promise.then(pdf => {
				this.numPages = pdf.numPages

			}).catch((err) => {
				console.error('pdf 加载失败')
				// err)
			})
		},
    IsPerm (perm_name) {


			return isPerm(this.perms, perm_name)
		},

    handleClickOutside() {
      this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    },
    logout() {
      this.$store.dispatch('FedLogOut').then(() => {
        Cookies.set('activeMenu', 0)
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      })
    },
    mainMenuSelect(index, indexPath) {
      // if(index != 0)
      Cookies.set('activeMenu', index)
      this.$store.commit('SET_MENU2', this.menu[index].children)
    },

    updatePwd() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.temp.pwd != this.temp.pwd1) {
            this.$notify({ title: '失败', message: '两次输入的新密码应一致', type: 'error', duration: 3000 })
            return
          }
          if (this.temp.old_pwd === this.temp.pwd1) {
            this.$notify({ title: '失败', message: '新密码不能与旧密码相同。', type: 'error', duration: 3000 })
            return
          }
          sys_user_api.updatePwd(this.temp).then((resp) => {
            if (resp.data && resp.data.success) {
              // this.list.unshift(this.temp)
              // this.pwdUpdated = false;
              // this.showUpdatePwdDiag = false;
              // this.$store.state.user.pwdUpdated = "是";
              // this.$notify({title: '成功',message: '修改成功',type: 'success',duration: 2000})
              this.$confirm('密码修改成功，请使用新密码重新登录系统', '提示', { showCancelButton: false, showClose: false, confirmButtonText: '确定' }).then(() => {
                this.logout()
              }).catch(() => {

              })
            } else if (resp.data && !resp.data.success) {
              this.$notify({ title: '失败', message: '修改失败:' + resp.data.remark, type: 'error', duration: 3000 })
            }
          })
        }
      })
    },
    showUpdatePwd() {
      this.showUpdatePwdDiag = true
      this.temp = {}
      this.$nextTick(() => {
        // this.$refs['dataForm'].clearValidate()
      })
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        // console.log(to.path)
        this.is_new_page=to.path.includes('new_page')
        if (to.path == '/stats') {
          this.is_stats = true
          window.location.reload();
        }else{
          if(this.is_stats){
            this.is_stats = false
          // window.location.reload();
          }
        }

      }
    }

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/mixin.scss';

.app-wrapper {
  //overflow:auto;
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.myTopBanner {
  //background:url(../../assets/imgs/333.jpg) repeat;
  background: #3377ff;
  position: fixed;
  width: 100%;
  height: 46px;

  .title {
    font-size: 22px;
    height: 100%;
    padding-left: 20px;

    line-height: 100%;

    font-weight: bold;
    color: #fff;
    letter-spacing: 3px;
    //text-shadow : 6px 6px 4px #000000;

    .title2 {
      //font-size:26px;
      letter-spacing: 0px;
      //font-family: FangSong;
      color: #fff;
    }
  }
}

.avatar-container {
  text-shadow: 0px 0px 0px #000000;
  color: #fff;
  float: right;
  cursor: pointer;
  margin-top: 8px;
  margin-right: 15px;
}

.el-menu-demo {
  //margin-top: -8px;

  //background:transparent;
  //text-shadow : 0px 0px 0px #000000;
  display: none;
  height: 45px;

  //padding-left:180px;
  .el-menu-item {
    //color:#ffffff;

    height: 45px;
  }
}

.el-menu--horizontal {
  //border-bottom: solid 1px rgb(48, 65, 86);
}

.el-menu--horizontal>.el-menu-item.is-active {
  color: #409eff;
}

.title3 {
  font-size: 19px;
  height: 100%;
  //padding-left:20px;
  //padding-top:12px;
  line-height: 52px;

  font-weight: bold;
  color: #19a1dd;
  //letter-spacing: 3px;
  text-shadow: 6px 6px 4px #000000;
  //font-size:26px;
  letter-spacing: 0px;
  //font-family: FangSong;
  //color: #fff;
}
</style>
<style rel="stylesheet/scss" lang="scss">
.el-table-column--selection .cell {
  text-overflow: unset;
  padding-left: 10px;
  padding-right: 10px;
}
</style>

<style rel="stylesheet/scss" lang="scss">
#mySwitch .el-switch__label.is-active {
  color: #fff;
}
.myTopBanner .active {
  background: red;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue